'use strict';
import React, {useState} from 'react';
import './App.css';

import lofi from './audio/lofi.mp3';
import classical from './audio/classical.mp3';
import jazz from './audio/jazz.mp3';

export const BgAudio = () => {
    const audios = {
        'lofi': lofi,
        'classical': classical,
        'jazz': jazz
}

    const [currentAudio, setCurrentAudio] = useState(null);
    const [currentLabel, setCurrentLabel] = useState(null);
    const [volume, setVolume] = useState(1);

    function toggleAudio(track) {
        // three interactions: stop music, start music, and change to other music

        if (!currentAudio) {
            const newAudio = new Audio(track);
            setCurrentAudio(newAudio);
            setCurrentLabel(track);
            newAudio.play();
        } else if (currentAudio && currentLabel === track){
            currentAudio.pause();
            setCurrentAudio(null);
        } else {
            currentAudio.pause()
            setCurrentAudio(null);

            const newAudio = new Audio(track);
            setCurrentAudio(newAudio);
            setCurrentLabel(track);
            newAudio.play();
    }
}

function handleVolume(value) {
    if (currentAudio) {
    setVolume(value);
    currentAudio.volume = volume;
    }
}

    return(
        <div className="bgm-toggle">
        <div className="section-container section-bgm">
            <h1>Music</h1>
            <div className="section-item">
                <div className="music-container">
                    <div className="music-item">
                        <div className="mix-container" onClick={() => toggleAudio(audios.lofi)}>
                            <img className="mix-item" src="img/lofi.jpg" alt="Lofi Playlist"/>
                            <p className="mix-item">Lofi Mix</p>
                        </div>
                    </div>
                    <div className="music-item">
                        <div className="mix-container" onClick={() => toggleAudio(audios.classical)}>
                            <img className="mix-item" src="img/piano.jpg" alt="Classical Playlist"/>
                            <p className="mix-item">Classical Mix</p>
                        </div>
                    </div>
                    <div className="music-item">
                        <div className="mix-container" onClick={() => toggleAudio(audios.jazz)}>
                            <img className="mix-item" src="img/jazz.jpg" alt="Jazz Playlist"/>
                            <p className="mix-item">Jazz Mix</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section-item">
            <div className="volume-container">
            <img className="volume-item" src="./img/unmuted.png" />
                <input className="volume-slider"
                type="range"
                min={0}
                max={1}
                step={0.02}
                value={volume}
                onChange={event => {
                    handleVolume(event.target.valueAsNumber)
                }} 
                />
                </div>
                </div>
        </div>
    </div>
    );
}

export default BgAudio;